var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCart = function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.553 17.5h10.83c.95 0 1.425 0 1.812-.172a2 2 0 0 0 .843-.703c.238-.35.323-.818.493-1.753l1.35-7.429c.06-.324.09-.486.044-.612a.5.5 0 0 0-.22-.264c-.116-.067-.281-.067-.61-.067H5.053m-3-4H3.37c.242 0 .364 0 .462.044a.5.5 0 0 1 .212.182c.06.09.078.21.116.45l2.787 17.649c.037.24.056.36.115.45a.5.5 0 0 0 .213.18c.098.045.22.045.462.045h11.316",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCart;